import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const ConsigneeApi = createApi({
  reducerPath: "ConsigneeApi",
  baseQuery,
  tagTypes: ["Consignee"],

  endpoints: (builder) => ({
    getCustomerConsignee: builder.query({
      query: ({ id }) => {
        return `/customers/consignee/${id}`;
      },

      transformResponse: (response) => {
        const rows = response?.data || [];
        const item = rows;
        const transformed = {
          ...item,
          id: item.customerConsigneeId, // ⭐ normalized ID
        };
        return transformed;
      },

      providesTags: ["Consignee"],
    }),

    createConsignee: builder.mutation({
      query: ({ id, ...data }) => {
        console.log("🟦 createConsignee() CALLED");
        console.log("🟩 Received ID:", id);
        console.log("🟨 Received Data:", data);

        const payload = {
          consignee: data,
        };

        console.log("🔥 Final Payload Sent to API:", payload);

        return {
          url: `/customers/consignee/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: payload,
        };
      },

      invalidatesTags: ["Consignee"],
    }),

    updateConsignee: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/customers/consignee/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: { consignee: data },
      }),
      invalidatesTags: ["Consignee"],
    }),
  }),
});

export const {
  useLazyGetCustomerConsigneeQuery,
  useCreateConsigneeMutation,
  useUpdateConsigneeMutation,
} = ConsigneeApi;
